import axios from "axios";
import store from '../store'

const basePath = "/api/"; //process.env.NODE_ENV === "development" ? "https://192.168.1.30:8080/api/" : "/api/";
axios.defaults.baseURL = basePath;

// pass the auth cookies
const requestInterceptor = (request) => {
    request.withCredentials = true;
    return request;
};
axios.interceptors.request.use((request) => requestInterceptor(request));

export default {
    basePath,
    getToken() {
        try {
            // console.log("token api", store.state.user.AccessToken);
            return store.state.user.AccessToken;
        } catch (e) {
            console.error(e)
            return "";
        }
    }
};